module.exports = __webpack_public_path__ + "static/media/cell@3x.24cfed1f.png";